import { TableCell } from '@mui/material';
import ICasTableColumn from '../ICasTableColumn';
import getCasTableCellValue from '../getCasTableCellValue';

interface ICasTableCell {
  row: any;
  column: ICasTableColumn;
  isExpanded?: boolean;
  onToggleExpand?: VoidFunction;
}

export default function CasTableCell({ row, column, ...rest }: ICasTableCell) {
  return (
    <TableCell
      sx={{
        whiteSpace: 'break-spaces',
        ...(column.sx ? column.sx(row, column) : {}),
      }}
    >
      {column.render ? column.render({ row, column, ...rest }) : getCasTableCellValue({row, column})}
    </TableCell>
  );
}
